import { createSelector } from 'reselect';

/**
 * @return {string} searchTerm
 */
export const getSearchTermSelector = createSelector(
  (state, match) => match.params.searchTerm,
  (searchTerm) => searchTerm
);

/**
 * @return {*} video
 */
export const getSearchSelectedVideoSelector = createSelector(
  (state, match) => {
    if (!match.params.videoId) return undefined;

    return state.collection.videos.find((video) => video.id === match.params.videoId);
  },
  (video) => video
);
